import React, { useState } from "react";
import { IUserInfo } from "utilFunctions/CommonInterfaces/userInterface";

export const ToastContext = React.createContext<any>(null);
export const UserInfoContext = React.createContext<any>(null);

export const ToastContextDispatch = React.createContext<any>(null);
export const UserInfoContextDispatch = React.createContext<any>(null);
export const SuccessfullyMessageBarDispatch = React.createContext<any>(null);
export const SuccessfullyMessageBarContext = React.createContext<any>(null);

export const VersionUpdateMessageBarDispatch = React.createContext<any>(null);
export const VersionUpdateMessageBarContext = React.createContext<any>(null);

export const ToastContextProvider = (props: any) => {
  const [isOpenToast, setIsOpenToast] = useState({
    isOpen: false,
    type: "",
    message: "",
    isNotificationType: false,
    secondaryMessage: "",
  });
  return (
    <ToastContext.Provider value={isOpenToast}>
      <ToastContextDispatch.Provider value={setIsOpenToast}>
        {props.children}
      </ToastContextDispatch.Provider>
    </ToastContext.Provider>
  );
};

export const UserInfoContextProvider = (props: any) => {
  const [userInfo, setUserinfo] = useState<IUserInfo>({
    user_name: "",
    username: "",
    role: "",
    id: 0,
    facId: 0,
    email: "",
    branch: "",
    class_id: 0,
    department: "",
    subjects: [],
    psid: null,
    branchId: "",
    branchName: "",
    idToStreamName: {},
    userStreams: [],
    employeeId: "",
    fexRole: "",
  });
  return (
    <UserInfoContext.Provider value={userInfo}>
      <UserInfoContextDispatch.Provider value={setUserinfo}>
        {props.children}
      </UserInfoContextDispatch.Provider>
    </UserInfoContext.Provider>
  );
};

export const SuccessfullyMessageBarProvider = (props: any) => {
  const [messageInfor, setMessageInfor] = useState<any>({
    message: "",
    isShow: false,
  });
  return (
    <SuccessfullyMessageBarContext.Provider value={messageInfor}>
      <SuccessfullyMessageBarDispatch.Provider value={setMessageInfor}>
        {props.children}
      </SuccessfullyMessageBarDispatch.Provider>
    </SuccessfullyMessageBarContext.Provider>
  );
};

export const VersionUpdateMessageBarProvider = (props: any) => {
  const [versionUpdateNeeded, setVersionUpdateNeeded] = useState<any>({
    message: "",
    isShow: false,
  });
  return (
    <VersionUpdateMessageBarContext.Provider value={versionUpdateNeeded}>
      <VersionUpdateMessageBarDispatch.Provider value={setVersionUpdateNeeded}>
        {props.children}
      </VersionUpdateMessageBarDispatch.Provider>
    </VersionUpdateMessageBarContext.Provider>
  );
};
